<ng-container *ngIf="!!page">
    <div class="filters">
        <tt-card>
            <tt-select
                ttRememberId="w_accountingprocessing.businessco_no"
                ttLabel="businessco"
                [(ttModel)]="page.businessco_no"
                (ttModelChange)="readGridWithColschema()"
                [ttData]="companies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
            <tt-checkbox ttRememberId="w_accusttranses.openpost" ttLabel="openpost" [(ttModel)]="page.openpost" (ttModelChange)="readGridWithColschema()"></tt-checkbox>
            <ng-container *ngIf="page.openpost === '0'">
                <tt-checkbox
                    ttRememberId="w_accusttranses.show_account_saldo"
                    ttLabel="show_account_saldo"
                    [(ttModel)]="page.show_account_saldo"
                    (ttModelChange)="readGridWithColschema()"
                ></tt-checkbox>
                <tt-date-range
                    ttRememberId="w_accusttranses"
                    ttLabel="date_fom_tom"
                    [(ttStartDate)]="page.date_fom"
                    [(ttEndDate)]="page.date_tom"
                    [(ttInterval)]="page.dateselector_index"
                    (ttModelChange)="readGridWithColschema()"
                ></tt-date-range>
            </ng-container>

            <ng-container *ngIf="page.openpost === '1'">
                <tt-date ttLabel="date_tom" [(ttModel)]="page.date_tom_open_post" (ttModelChange)="readGridWithColschema()"></tt-date>
                <tt-toast *ngIf="page.date_tom_open_post !== page.date_today" ttType="danger" [ttTitle]="page.date_not_today_warning" ttTranslateTitle="false"></tt-toast>
            </ng-container>
        </tt-card>
        <tt-card>
            <!--
            <tt-button
                *ngIf="page.openpost === '1'"
                ttText="accusttranses_remove_matching"
                (ttClick)="removeMatching()"
                [ttLoading]="removing"
                ttIcon="fas fa-sync-alt"
            ></tt-button>
            -->
            <tt-button
                *ngIf="page.openpost === '1' && page.date_tom_open_post === page.date_today"
                ttText="accusttranses_match"
                (ttClick)="match()"
                [ttLoading]="matching"
                ttIcon="fas fa-sync-alt"
            ></tt-button>
            <tt-button *ngIf="+page.acc_cust_no > 0" ttText="accusttranses_automatch" (ttClick)="autoMatch()" [ttLoading]="autoMatching" ttIcon="fas fa-sync-alt"></tt-button>
            <tt-search-multi-select
                *ngIf="page.acc_cust_no === '0'"
                ttRememberId="w_accusttranses.customers"
                ttModelSetting="object"
                ttLabel="cust_nos"
                [(ttModel)]="page.customers"
                (ttModelChange)="readGrid()"
                [ttData]="searchCustomers"
                ttShowClearButton
            ></tt-search-multi-select>
        </tt-card>
    </div>

    <tt-grid *ngIf="grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
